import { STATIC_WORKOUT_TYPES } from '../../data/staticSportData';
import { isRunningWorkout, type RunningWorkout } from '../../utils/runningWorkoutMetrics';
import type { PeakCategory } from '../../utils/recordHistoryEnums';

// The canonical workout catalogue mirrors WorkoutTypeSeeder (Run = running).
export const RUNNING_RECORD_SPORT = STATIC_WORKOUT_TYPES.find(type => type.english_name === 'Run')!;

export function recordSportId(category: PeakCategory, selectedSportId: string): string {
  return category === 'pace' ? String(RUNNING_RECORD_SPORT.id) : selectedSportId;
}

type RecordWorkout = RunningWorkout & { workout_type_id?: number | null };

/** Unknown or non-running workouts cannot contribute a running pace record. */
export function recordsForCategory<T extends { workout?: RecordWorkout | null }>(
  records: T[],
  category: PeakCategory,
): T[] {
  if (category !== 'pace') return records;
  return records.filter(record => {
    const workout = record.workout;
    if (!workout) return false;
    return isRunningWorkout({
      ...workout,
      workout_type: {
        ...workout.workout_type,
        id: workout.workout_type?.id ?? workout.workout_type_id ?? undefined,
      },
    });
  });
}
